<div class="container" style="width: 60px">
  <select (change)="setLanguage($event.target.value)" [value]="currentLanguage">
    <option value="en">EN</option>
    <option value="nl">NL</option>
    <option value="fr">FR</option>
    <option value="de">DE</option>
    <option value="da">DA</option>
    <option value="pl">PL</option>
  </select>
</div>
